module.exports = __webpack_public_path__ + "static/media/MobileSellkeyFunction01.e607b7d4.png";